import { Chance } from "chance"
import { ExtractSupplier } from "etl/types";

const chance = new Chance();

export const extractSupplierFactoryMock = (howMany: number): ExtractSupplier[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/extract_suppliers/${index + 1}`,
		"@type": "ExtractSupplier",
		actif: chance.word(),
		id: index + 1,
		libelle: chance.word(),
		aw_company_id: chance.integer().toString(),
		hb_id: chance.integer().toString(),
	}));
